import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import '@/assets/css/tailwind.css';
import '@aws-amplify/ui-vue/styles.css';
import '@/assets/css/global.css';
import { Amplify } from 'aws-amplify';
import amplifyOutputs from '../amplify_outputs.json';

Amplify.configure(amplifyOutputs);

createApp(App).use(router).mount('#app');
